<div class="container-fluid">
  <form #wiForm="ngForm">
    <!-- Header -->
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>{{ headerText }}</h3>
      </div>

      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <button
            type="button"
            class="btn btn-default btn-sm"
            *ngIf="wiForm.form.dirty"
            (click)="cancelTraveler()" >
            <i class="fas fa-ban"></i>&nbsp;Clear
          </button>
          <button
            *ngIf="(wiForm.form.valid && wiForm.form.dirty) "
            type="button"
            class="btn btn-default btn-sm"
            (click)="saveTraveler(traveler)" >
            <i class="fas fa-save"></i>&nbsp;Save
          </button>
          <button
            type="button"
            class="btn btn-default btn-sm"
          >
            <i class="fas fa-print"></i>&nbsp;Print BOM
          </button>
        </div>
      </div>
    </div>
    <hr style="margin-top: 2px; margin-bottom: 12px" />

    <aims-form [editable]="calculateEditable()" [cols]="1" [spaceRows]="true">
      <aims-fc [labelColSize]="2" [controlColSize]="6">
        <mat-form-field appearance="fill">
          <input
            matInput
            #aimsControl="ngModel"
            id="description"
            type="text"
            name="Description"
            maxlength="80"
            [(ngModel)]="traveler.description"
            required />
          </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="3">
        <mat-form-field appearance="fill">
          <input
            matInput
            #aimsControl="ngModel"
            class="fullWidth"
            id="revision"
            type="text"
            name="Revision"
            maxlength="30"
            [(ngModel)]="traveler.revision"
            required />
          </mat-form-field>
      </aims-fc>

      <aims-fc [labelColSize]="2" [controlColSize]="3">

        <mat-form-field appearance="fill">
          <mat-select
            #aimsControl="ngModel"
            name="Status"
            [(ngModel)]="traveler.status"
            required>
              <mat-option *ngFor="let s of travelerStatuses | async" [value]="s.statusCode">
                  {{ s.statusCode }} - {{ s.status }}
              </mat-option>
          </mat-select>
        </mat-form-field>

      </aims-fc>
    </aims-form>
  </form>

    <app-inventory-documents
      [documents]="documents"
      [attachedToId]="traveler.travelerId"
      [attachedToType]="'traveler'"
      (RowAdded)="loadTravelerDocuments(traveler.travelerId)"
      (RowDeleted)="loadTravelerDocuments(traveler.travelerId)"
    ></app-inventory-documents>

  <ng-container *ngIf="showAddPart()">
    <div class="row top10">
      <div class="col-xs-12">
        <aims-form
          [cols]="1"
          [header]="'Add Inventory'"
          [spaceRows]="true" >
          <app-add-inventory-item [IsWorkOrder]="false" (AddInventoryItemEvent)="addItemToTraveler($event)"></app-add-inventory-item>
        </aims-form>
      </div>
    </div>
  </ng-container>
  <hr/>

  <aims-common-table
    id="pulled-parts-table"
    [dataSource]="attachedItems"
    [header]="header"
    [permissions]="tablePermissions"
    label="Pulled Inventory"
    pageSize="5"
    [footer]="true"
    [stickyHeader]="true">

    <aims-common-table-dynamic-row id="quantity">
      <ng-template viewMode let-element >
        {{ getAttachedItemPulledQuantity(element.attachedItemId) }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="partCost">
      <ng-template viewMode let-element >
        {{ getAttachedItemPulledCost(element.attachedItemId) | currency: "USD":"symbol":"1.2-4" }}
      </ng-template>

      <ng-template aimsFooterTemplate let-element>
        {{ getTotalAttachedItemsPulledCost() | currency: "USD":"symbol":"1.2-4" }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <!-- sub-table -->
    <ng-template aimsCommonTableExpandedRow let-element>
      <mat-card>
      <aims-common-table
        label=""
        [id]="'pulled-detail-table-' + element.position"
        class="sub-table"
        [dataSource]="element.invAttachedItemPulled"
        [header]="subTableHeader"
        [permissions]="{ filter: false, create: false, update: false, 'delete': false }"
      >
        <aims-common-table-dynamic-row id="unitCost">
          <ng-template viewMode let-element >
            {{ element.inventoryItemReceived.costPerUnit | currency: "USD":"symbol":"1.2-4" }}
          </ng-template>

        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="pulledByEmployeeId">
          <ng-template viewMode let-element >
             {{ element.pulledByEmployeeId| getText:'employeeId':'fullName':employeeValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

      </aims-common-table>
      </mat-card>
    </ng-template>
  </aims-common-table>

  <!-- <div style="float: right; padding: 20px 10px;">
    <mat-card>
    Total Parts Cost:
    {{ getTotalAttachedItemsPulledCost() | currency: "USD":"symbol":"1.2-4" }}
    </mat-card>
  </div> -->

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner" ></aims-spinner>
</div>
